import { checkAxiosData, getAxiosConfig } from 'fe-common'
import { from, concatMap, filter, tap } from 'rxjs'

import { handleMessages, refreshToken } from '../../modules/client/utilities'

export default {
  namespaced: true,
  state: () => ({
    // 個人資料
    realName: null,
    accountFirstName: null,
    accountLastName: null,
    email: null,
    birthday: null,
    wechatNo: null,
    qqNo: null,
    zaloNo: null,
    lineId: null,
    twitterId: null,
    idNumber: null,
    whatsApp: null,
    address: null,
    tel: null, // string || intelinput object
    isTelValid: null,
    telVerifyCode: null,
    emailVerifyCode: null,
    sendTelVerifyCodeTime: 0,
    sendTelVerifyCodeInterval: 240,

    // 銀行卡資料
    bankCardNo: null,
    bankCardName: null,
    bankCardOpeningBranch: null, // 开户支行
    isValidBankCard: true,

    // 信用卡資料
    creditCardType: null,
    creditCardNumber: null,
    creditCardExpirationMonth: null,
    creditCardExpirationYear: null,
    creditCardHolderFirstName: null,
    creditCardHolderLastName: null,
    creditCardCity: null,
    creditCardPostalCode: null,
    creditCardStreet: null,
    isCanBindCreditCard: false, // 是否可以綁定信用卡
    creditCardKycSubCategories: [], // 新增信用卡的kyc的subCategory列表

    // 第三方支付
    thirdPartyPayVendors: [],
    selectedThirdPartyPayVendor: null,
    selectedThirdPartyPayVendorId: null,

    // (by all comp)
    thirdPartyAccount: null, // 帳戶/卡號
    thirdPartyAccountName: null, // 帳戶姓名

    thirdPartyEmail: null,
    thirdPartyVCurrencyTypes: ['BTC', 'ETH', 'LTC'],
    selectedThirdPartyVCurrencyType: null,
    thirdPartyVCurrencyAddress: null,
    thirdPartyVCurrencyDestinationTag: null,
    thirdPartyFirstName: null,
    thirdPartyLastName: null,
    // thirdPayment bank
    thirdPartyBanks: [], // 銀行清單
    selectedThirdPartyBankCode: null, // 銀行代碼
    thirdPartyBankBranchCode: null,
    thirdPartyBankBranchName: null,
    thirdPartyBankKatakana: null,
    // fd2 thirdPayment pix
    thirdPartyWalletTypes: [
      { key: 'CPF', name: 'PIX-CPF' },
      { key: 'CNPJ', name: 'PIX-CNPJ' },
      { key: 'EMAIL', name: 'PIX-EMAIL' },
      { key: 'PHONE', name: 'PIX-MOBILE' }
    ],
    selectedThirdPartyWalletType: null,
    thirdPartyPhone: null,
    thirdPartyCNPJ: null,
    thirdPartyCPFNumber: null,

    // (by bs, demo, zh, st comp)
    thirdPartyBankProvince: null, // 銀行省份
    thirdPartyBankCity: null, // 銀行城市
    thirdPartyBankAddress: null, // 銀行分行
    thirdPartyBankAccount: null // 銀行帳戶 // todo
  }),
  actions: {
    updatePersonalData({ dispatch, rootState }, payload = null) {
      return dispatch('updateUserInfo', payload)
    },
    updateUserInfo(context, payload = null) {
      const { state } = context
      const data = payload || {
        email: '',
        wechat: '',
        qq: state.qqNo || '',
        zalo: state.zaloNo || '',
        line: state.lineId || '',
        twitter: state.twitterId || '',
        address: state.address || ''
      }
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/user/updateUserInfo`,
                data,
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    checkTelValid(context) {
      const { state } = context
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/user/checkPhone`,
                {
                  phone: state.tel
                },
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    sendTelVerifyCode(context) {
      const { rootState, dispatch } = context
      const data = {
        imageCode: rootState.authModule.imageCode
      }

      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/user/sendValidateSms`,
                data,
                getAxiosConfig(context, {
                  headers: {
                    Authorization: 'Bearer ' + rootState.authModule.token,
                    '6cfsezdad3': rootState.authModule.imageToken
                  }
                })
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(() => {
            dispatch('reSendTelVerifyCodeTime').then()
          })
        )
        .toPromise()
    },
    validateTelVerifyCode(context) {
      const { state } = context
      const data = {
        smsCode: state.telVerifyCode
      }

      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/user/validateSms`,
                data,
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    sendEmailVerify(context, payload) {
      const { state, rootState } = context

      const data = {
        email: payload || state.email,
        domain: rootState.domain
      }

      return this.$axios.$post(
        `/webapi/index/sendEmailVerify`,
        data,
        getAxiosConfig(context)
      )
    },
    reSendTelVerifyCodeTime({ commit, state }) {
      if (['fd2'].includes(process.env.COMP_ID)) {
        commit('SEND_TEL_VERIFY_CODE_INTERVAL', 8 * 60)
      }
      commit('SEND_TEL_VERIFY_CODE_TIME', state.sendTelVerifyCodeInterval)
      const sendTelVerifyCodeTimeIntervalId = setInterval(() => {
        commit('SEND_TEL_VERIFY_CODE_TIME', state.sendTelVerifyCodeTime - 1)
        if (state.sendTelVerifyCodeTime === 0)
          clearInterval(sendTelVerifyCodeTimeIntervalId)
      }, 1000)
    },

    getBankList(context) {
      const isoCountryCode = process.env.DEFAULT_COUNTRY

      return from(
        this.$axios.$get(
          `/webapi/user/bankCard/bankList?isoCountryCode=${isoCountryCode}`
        )
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          )
        )
        .toPromise()
    },
    bindBankCard(context, payload) {
      const { state } = context

      // retrieve data from passed data or values in store
      const data = payload || {
        bankno: state.bankCardNo
      }

      if (state.bankCardOpeningBranch) {
        data.openingBranch = state.bankCardOpeningBranch
      }

      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/user/bankCard/bind`,
                data,
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    updateBankCard(context, payload) {
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/user/bankCard/update`,
                payload,
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },

    bindCreditCard(context, payload) {
      const { state, rootState } = context
      const data = new FormData()

      const creditCard = {
        cardType: state.creditCardType,
        cardNumber: state.creditCardNumber,
        expireMonth: state.creditCardExpirationMonth,
        expireYear: '20' + state.creditCardExpirationYear,
        firstName: state.creditCardHolderFirstName,
        lastName: state.creditCardHolderLastName,
        country: rootState.userModule.selectedCountry,
        city: state.creditCardCity,
        postcode: state.creditCardPostalCode,
        street: state.creditCardStreet
      }

      Object.keys(payload.files).map(key => {
        data.append(key, payload.files[key])
      })
      data.append('userFilesJsonString', JSON.stringify(payload.params))
      data.append('creditCardBindJsonString', JSON.stringify(creditCard))

      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/user/userCreditCard/bind`,
                data,
                getAxiosConfig(context, { timeout: 10 * 1000 })
              )
            )
          )
        )
        .toPromise()
    },
    checkBindingCreditCard(context) {
      const { commit } = context
      commit('IS_CAN_BIND_CREDIT_CARD', false)
      commit('CREDIT_CARD_KYC_SUB_CATEGORIES', [])

      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/user/userCreditCard/bindingCheck`,
                {},
                getAxiosConfig(context)
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit('IS_CAN_BIND_CREDIT_CARD', true)
            commit(
              'CREDIT_CARD_KYC_SUB_CATEGORIES',
              data.subcategory.split(',')
            )
          })
        )
        .toPromise()
    },

    getThirdPartyPayVendors(context) {
      const { commit } = context
      commit('THIRD_PARTY_PAY_VENDORS', [])

      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/payment/getThirdPaymentInfo`,
                {},
                getAxiosConfig(context)
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit('THIRD_PARTY_PAY_VENDORS', data || [])
          })
        )
        .toPromise()
    },
    getThirdPartyBanks(context) {
      const { state, commit } = context
      commit('THIRD_PARTY_BANKS', [])

      let opId = state.selectedThirdPartyPayVendorId
      let data = {}
      if (['kb', 'sk1'].includes(process.env.COMP_ID)) {
        // 這裏是直接畫面 option 設置 selectedThirdPartyPayVendor 物件，而非 selectedThirdPartyPayVendorId 數值
        opId = state.selectedThirdPartyPayVendor.opId
        data = {
          payPlatform: state.selectedThirdPartyPayVendor.displayName,
          vendorCode: state.selectedThirdPartyPayVendor.vendorCode
        }
      }

      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/payment/getThirdBankList/${opId}`,
                data,
                getAxiosConfig(context)
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit('THIRD_PARTY_BANKS', data || [])
          })
        )
        .toPromise()
    },
    bindThirdPartyPay(context) {
      const { state } = context

      const data = {}
      const selectedThirdPartyPayVendor = state.selectedThirdPartyPayVendor
      data.id = selectedThirdPartyPayVendor.opId

      if (selectedThirdPartyPayVendor.displayName === 'iWallet') {
        data.walletAccount = state.thirdPartyAccount
      }
      if (selectedThirdPartyPayVendor.displayName === 'STICPAY') {
        data.walletAccount = state.thirdPartyEmail
      }
      if (selectedThirdPartyPayVendor.displayName === 'VENUS-POINT') {
        data.walletAccount = state.thirdPartyAccount
      }
      if (selectedThirdPartyPayVendor.displayName === 'VEGA') {
        data.walletAccount = state.thirdPartyAccount
      }
      if (selectedThirdPartyPayVendor.displayName === 'Coinbase') {
        data.virtualCurrency = state.selectedThirdPartyVCurrencyType
        data.walletAccount = state.thirdPartyVCurrencyAddress
      }
      if (selectedThirdPartyPayVendor.typeName === 'vCurrency') {
        data.virtualCurrency = selectedThirdPartyPayVendor.displayName
        data.walletAccount = state.thirdPartyVCurrencyAddress
        if (state.thirdPartyVCurrencyDestinationTag) {
          data.destinationTag = state.thirdPartyVCurrencyDestinationTag
        }
      }
      if (selectedThirdPartyPayVendor.typeName === 'thirdPayment') {
        switch (selectedThirdPartyPayVendor.displayName) {
          case 'pix':
            data.bankCode = selectedThirdPartyPayVendor.displayName
            data.accountType = state.selectedThirdPartyWalletType
            switch (state.selectedThirdPartyWalletType) {
              case 'PHONE':
                data.walletAccount = state.thirdPartyPhone
                break
              case 'EMAIL':
                data.walletAccount = state.thirdPartyEmail
                break
              case 'CNPJ':
                data.walletAccount = state.thirdPartyCNPJ
                break
              case 'CPF':
                data.walletAccount = state.thirdPartyCPFNumber
                break
              default:
                break
            }
            break
          default:
            data.walletAccount = state.thirdPartyAccount
            data.bankCode = state.selectedThirdPartyBankCode

            if (state.thirdPartyBankBranchCode) {
              data.openingBranchCode = state.thirdPartyBankBranchCode
            }
            if (state.thirdPartyBankBranchName) {
              data.openingBranch = state.thirdPartyBankBranchName
            }

            if (state.thirdPartyAccountName) {
              data.accountName = state.thirdPartyAccountName
            } else {
              data.accountFirstName = state.thirdPartyFirstName
              data.accountLastName = state.thirdPartyLastName
            }
            break
        }
      }
      if (
        ['ecoPayz', 'Payz'].includes(selectedThirdPartyPayVendor.displayName)
      ) {
        data.walletAccount = state.thirdPartyAccount
      }
      if (selectedThirdPartyPayVendor.displayName === 'Accentpay') {
        data.walletAccount = state.thirdPartyAccount
      }
      if (selectedThirdPartyPayVendor.displayName === 'TigerPay') {
        data.walletAccount = state.thirdPartyAccount
      }
      if (selectedThirdPartyPayVendor.displayName === 'CrownPoint') {
        data.walletAccount = state.thirdPartyAccount
        data.bankCode = state.selectedThirdPartyBankCode
        data.accountName = state.thirdPartyAccountName
        data.openingBranch = state.thirdPartyBankBranchName
        data.openingBranchCode = state.thirdPartyBankBranchCode
      }
      if (selectedThirdPartyPayVendor.typeName === 'ebank') {
        data.walletAccount = state.thirdPartyAccount
        data.bankCode = state.selectedThirdPartyBankCode
        data.openingBranch = state.thirdPartyBankBranchName
        data.openingBranchCode = state.thirdPartyBankBranchCode
        data.accountName = state.thirdPartyAccountName
        data.katakana = state.thirdPartyBankKatakana
      }
      if (selectedThirdPartyPayVendor.displayName === 'MatchPay') {
        data.walletAccount = state.thirdPartyAccount
      }
      if (selectedThirdPartyPayVendor.displayName === 'Jeton') {
        data.walletAccount = state.thirdPartyAccount
      }

      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/user/userThirdPayment/bind`,
                data,
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    }
  },
  mutations: {
    REAL_NAME(state, payload) {
      state.realName = payload
    },
    ACCOUNT_FIRST_NAME(state, payload) {
      state.accountFirstName = payload
    },
    ACCOUNT_LAST_NAME(state, payload) {
      state.accountLastName = payload
    },
    EMAIL(state, payload) {
      state.email = payload
    },
    BIRTHDAY(state, payload) {
      state.birthday = payload
    },
    WECHAT_NO(state, payload) {
      state.wechatNo = payload
    },
    QQ_NO(state, payload) {
      state.qqNo = payload
    },
    ZALO_NO(state, payload) {
      state.zaloNo = payload
    },
    LINE_ID(state, payload) {
      state.lineId = payload
    },
    TWITTER_ID(state, payload) {
      state.twitterId = payload
    },
    ID_NUMBER(state, payload) {
      state.idNumber = payload
    },
    WHATS_APP(state, payload) {
      state.whatsApp = payload
    },
    ADDRESS(state, payload) {
      state.address = payload
    },
    TEL(state, payload) {
      state.tel = payload
    },
    TEL_VERIFY_CODE(state, payload) {
      state.telVerifyCode = payload
    },
    EMAIL_VERIFY_CODE(state, payload) {
      state.emailVerifyCode = payload
    },
    SEND_TEL_VERIFY_CODE_TIME(state, payload) {
      state.sendTelVerifyCodeTime = payload
    },
    SEND_TEL_VERIFY_CODE_INTERVAL(state, payload) {
      state.sendTelVerifyCodeInterval = payload
    },

    BANK_CARD_NO(state, payload) {
      state.bankCardNo = payload
    },
    BANK_CARD_NAME(state, payload) {
      state.bankCardName = payload
    },
    BANK_CARD_OPENING_BRANCH(state, payload) {
      state.bankCardOpeningBranch = payload
    },
    IS_VALID_BANK_CARD(state, payload) {
      state.isValidBankCard = payload
    },

    CREDIT_CARD_TYPE(state, payload) {
      state.creditCardType = payload
    },
    CREDIT_CARD_NUMBER(state, payload) {
      state.creditCardNumber = payload
    },
    CREDIT_CARD_EXPIRATION_MONTH(state, payload) {
      state.creditCardExpirationMonth = payload
    },
    CREDIT_CARD_EXPIRATION_YEAR(state, payload) {
      state.creditCardExpirationYear = payload
    },
    CREDIT_CARD_HOLDER_FIRST_NAME(state, payload) {
      state.creditCardHolderFirstName = payload
    },
    CREDIT_CARD_HOLDER_LAST_NAME(state, payload) {
      state.creditCardHolderLastName = payload
    },
    CREDIT_CARD_CITY(state, payload) {
      state.creditCardCity = payload
    },
    CREDIT_CARD_POSTAL_CODE(state, payload) {
      state.creditCardPostalCode = payload
    },
    CREDIT_CARD_STREET(state, payload) {
      state.creditCardStreet = payload
    },
    IS_CAN_BIND_CREDIT_CARD(state, payload) {
      state.isCanBindCreditCard = payload
    },
    CREDIT_CARD_KYC_SUB_CATEGORIES(state, payload) {
      state.creditCardKycSubCategories = payload
    },

    THIRD_PARTY_PAY_VENDORS(state, payload) {
      state.thirdPartyPayVendors = payload
    },
    SELECTED_THIRD_PARTY_PAY_VENDOR(state, payload) {
      state.selectedThirdPartyPayVendor = payload
    },
    SELECTED_THIRD_PARTY_PAY_VENDOR_ID(state, payload) {
      state.selectedThirdPartyPayVendorId = payload
    },

    THIRD_PARTY_BANK_ACCOUNT(state, payload) {
      state.thirdPartyBankAccount = payload
    },
    THIRD_PARTY_EMAIL(state, payload) {
      state.thirdPartyEmail = payload
    },
    THIRD_PARTY_V_CURRENCY_TYPES(state, payload) {
      state.thirdPartyVCurrencyTypes = payload
    },
    SELECTED_THIRD_PARTY_V_CURRENCY_TYPE(state, payload) {
      state.selectedThirdPartyVCurrencyType = payload
    },
    THIRD_PARTY_V_CURRENCY_ADDRESS(state, payload) {
      state.thirdPartyVCurrencyAddress = payload
    },
    THIRD_PARTY_V_CURRENCY_DESTINATION_TAG(state, payload) {
      state.thirdPartyVCurrencyDestinationTag = payload
    },
    THIRD_PARTY_FIRST_NAME(state, payload) {
      state.thirdPartyFirstName = payload
    },
    THIRD_PARTY_LAST_NAME(state, payload) {
      state.thirdPartyLastName = payload
    },
    THIRD_PARTY_BANK_BRANCH_CODE(state, payload) {
      state.thirdPartyBankBranchCode = payload
    },
    THIRD_PARTY_BANK_BRANCH_NAME(state, payload) {
      state.thirdPartyBankBranchName = payload
    },
    THIRD_PARTY_BANK_KATAKANA(state, payload) {
      state.thirdPartyBankKatakana = payload
    },
    THIRD_PARTY_WALLET_TYPES(state, payload) {
      state.thirdPartyWalletTypes = payload
    },
    SELECTED_THIRD_PARTY_WALLET_TYPE(state, payload) {
      state.selectedThirdPartyWalletType = payload
    },
    THIRD_PARTY_PHONE(state, payload) {
      state.thirdPartyPhone = payload
    },
    THIRD_PARTY_CNPJ(state, payload) {
      state.thirdPartyCNPJ = payload
    },
    THIRD_PARTY_THIRD_CPF_NUMBER(state, payload) {
      state.thirdPartyCPFNumber = payload
    },

    THIRD_PARTY_ACCOUNT_NAME(state, payload) {
      state.thirdPartyAccountName = payload
    },
    THIRD_PARTY_ACCOUNT(state, payload) {
      state.thirdPartyAccount = payload
    },
    THIRD_PARTY_BANKS(state, payload) {
      state.thirdPartyBanks = payload
    },
    SELECTED_THIRD_PARTY_BANK_CODE(state, payload) {
      state.selectedThirdPartyBankCode = payload
    },
    THIRD_PARTY_BANK_PROVINCE(state, payload) {
      state.thirdPartyBankProvince = payload
    },
    THIRD_PARTY_BANK_CITY(state, payload) {
      state.thirdPartyBankCity = payload
    },
    THIRD_PARTY_BANK_ADDRESS(state, payload) {
      state.thirdPartyBankAddress = payload
    }
  },
  getters: {
    realName: state => state.realName,
    accountFirstName: state => state.accountFirstName,
    accountLastName: state => state.accountLastName,
    email: state => state.email,
    birthday: state => state.birthday,
    wechatNo: state => state.wechatNo,
    qqNo: state => state.qqNo,
    zaloNo: state => state.zaloNo,
    lineId: state => state.lineId,
    twitterId: state => state.twitterId,
    idNumber: state => state.idNumber,
    whatsApp: state => state.whatsApp,
    address: state => state.address,
    tel: state => state.tel,
    telVerifyCode: state => state.telVerifyCode,
    emailVerifyCode: state => state.emailVerifyCode,
    sendTelVerifyCodeTime: state => state.sendTelVerifyCodeTime,
    sendTelVerifyCodeInterval: state => state.sendTelVerifyCodeInterval,

    bankCardNo: state => state.bankCardNo,
    bankCardName: state => state.bankCardName,
    bankCardOpeningBranch: state => state.bankCardOpeningBranch,
    isValidBankCard: state => state.isValidBankCard,

    creditCardType: state => state.creditCardType,
    creditCardNumber: state => state.creditCardNumber,
    creditCardExpirationMonth: state => state.creditCardExpirationMonth,
    creditCardExpirationYear: state => state.creditCardExpirationYear,
    creditCardHolderFirstName: state => state.creditCardHolderFirstName,
    creditCardHolderLastName: state => state.creditCardHolderLastName,
    selectedCountry: state => state.selectedCountry,
    creditCardCity: state => state.creditCardCity,
    creditCardPostalCode: state => state.creditCardPostalCode,
    creditCardStreet: state => state.creditCardStreet,
    isCanBindCreditCard: state => state.isCanBindCreditCard,
    creditCardKycSubCategories: state => state.creditCardKycSubCategories,

    thirdPartyPayVendors: state => state.thirdPartyPayVendors,
    selectedThirdPartyPayVendor: state => state.selectedThirdPartyPayVendor,
    selectedThirdPartyPayVendorId: state => state.selectedThirdPartyPayVendorId,

    thirdPartyEmail: state => state.thirdPartyEmail,
    thirdPartyVCurrencyTypes: state => state.thirdPartyVCurrencyTypes,
    selectedThirdPartyVCurrencyType: state =>
      state.selectedThirdPartyVCurrencyType,
    thirdPartyVCurrencyAddress: state => state.thirdPartyVCurrencyAddress,
    thirdPartyVCurrencyDestinationTag: state =>
      state.thirdPartyVCurrencyDestinationTag,
    thirdPartyFirstName: state => state.thirdPartyFirstName,
    thirdPartyBankBranchCode: state => state.thirdPartyBankBranchCode,
    thirdPartyBankBranchName: state => state.thirdPartyBankBranchName,
    thirdPartyBankKatakana: state => state.thirdPartyBankKatakana,
    thirdPartyWalletTypes: state => state.thirdPartyWalletTypes,
    selectedThirdPartyWalletType: state => state.selectedThirdPartyWalletType,
    thirdPartyPhone: state => state.thirdPartyPhone,
    thirdPartyCNPJ: state => state.thirdPartyCNPJ,
    thirdPartyCPFNumber: state => state.thirdPartyCPFNumber,

    thirdPartyAccountName: state => state.thirdPartyAccountName,
    thirdPartyAccount: state => state.thirdPartyAccount,
    thirdPartyBankAccount: state => state.thirdPartyBankAccount,
    thirdPartyBanks: state => state.thirdPartyBanks,
    selectedThirdPartyBankCode: state => state.selectedThirdPartyBankCode,
    thirdPartyBankProvince: state => state.thirdPartyBankProvince,
    thirdPartyBankCity: state => state.thirdPartyBankCity,
    thirdPartyBankAddress: state => state.thirdPartyBankAddress
  }
}
